import KunLoading98 from './src/index'

KunLoading98.install = function (Vue) {
	Vue.component(KunLoading98.name, KunLoading98);
}

export default KunLoading98;
